import FilterParamsUtil from "../sections/collection-grid/filter-params-util";
import { isMobile } from "../common/utils";

const CollectionGridHeader = (el, sectionParams, onChangeFilterParams, onFilterButtonClicked) => {
  let filterParams = [];

  const initialize = () => {
    el.querySelector(".fs-floating-filter-button").addEventListener("click", onFilterButtonClicked);
    el.querySelector(".fs-filter-button").addEventListener("click", onFilterButtonClicked);
    el.querySelector(".fs-sort-label").addEventListener("click", (e) => {
      el.querySelector(".fs-sort-submenu").classList.add("show");
      el.querySelector(".fs-sort-submenu-overlay").classList.add("show");
    });
    el.querySelector(".fs-sort-submenu-overlay").addEventListener("click", (e) => {
      el.querySelector(".fs-sort-submenu").classList.remove("show");
      el.querySelector(".fs-sort-submenu-overlay").classList.remove("show");
    });
    window.addEventListener("scroll", () => {
      el.querySelector(".fs-sort-submenu").classList.remove("show");
      el.querySelector(".fs-sort-submenu-overlay").classList.remove("show");

      if (isMobile) {
        const floatingButtonEl = el.querySelector(".fs-floating-filter-button");
        const collectionGridEl = document.querySelector(".fs-collection-grid");
        const rect = collectionGridEl.getBoundingClientRect();
        if (rect.bottom < window.innerHeight * 0.5) {
          floatingButtonEl.classList.add("hide");
        } else {
          floatingButtonEl.classList.remove("hide");
        }
      }
    });

    el.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", (e) => {
        el.querySelector(".fs-sort-submenu").classList.remove("show");
        el.querySelector(".fs-sort-submenu-overlay").classList.remove("show");

        if (e.target.name == "sort_type") {
          if (e.target.checked) {
            const newFilterParams = filterParams.filter((kv) => kv.key != "sort_type");
            onChangeFilterParams([...newFilterParams, { key: e.target.name, value: e.target.value }]);
            return;
          }
          const newFilterParams = filterParams.filter((kv) => kv.key != e.target.name || kv.value != e.target.value);
          onChangeFilterParams(newFilterParams);
          return;
        }

        if (e.target.checked) {
          onChangeFilterParams([...filterParams, { key: e.target.name, value: e.target.value }]);
          return;
        }
        const newFilterParams = filterParams.filter((kv) => kv.key != e.target.name || kv.value != e.target.value);
        onChangeFilterParams(newFilterParams);
        return;
      });
    });
  };

  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams;

    const shouldAlgoliasearchKeys = FilterParamsUtil.shouldAlgoliasearchKeys;
    if (0 <= filterParams.findIndex((kv) => shouldAlgoliasearchKeys.includes(kv.key))) {
      el.querySelector(".fs-row.all-top").classList.add("hidden");
    } else {
      el.querySelector(".fs-row.all-top").classList.remove("hidden");
    }

    // 2025-05-30 暫定対応
    el.querySelector(".fs-row.all-top").classList.add("hidden");

    el.querySelectorAll("input").forEach((input) => {
      input.checked = false;
      if (0 <= newFilterParams?.findIndex((kv) => kv.key == input.name && kv.value == input.value)) {
        input.checked = true;
      }
    });

    const currentSortType = FilterParamsUtil.currentSortType(newFilterParams, sectionParams);
    const sortTypeString = {
      published_at_desc: "新着順",
      price_asc: "価格：安い順",
      price_desc: "価格：高い順",
    }[currentSortType];

    el.querySelector(".fs-sort .fs-sort-label label").textContent = sortTypeString ?? "並び替え";
  };

  const setHeaderDetailText = (text) => {
    el.querySelector(".fs-collection-grid-header-detail").textContent = text;
  };

  initialize();

  return {
    setFilterParams: setFilterParams,
    setHeaderDetailText: setHeaderDetailText,
  };
};

export default CollectionGridHeader;
